import React, { useState, useEffect } from 'react';
import { TopPage } from './top/TopPage';
import { LoginPage } from './login';
import SignUpPage from './registration';
import { executeGet } from '@/client/rest';
import { FacilityResponseType } from '@/features/reservation/types/FacilityResponseType';

export enum PageSegment {
  Top = 'TOP',
  Registration = 'REGISTRATION',
  Login = 'LOGIN'
}

export const AuthPage = (props: {
  fromLine?: boolean; // LINEから遷移してきたかの判定
}) => {
  const [activePage, setActivePage] = useState(PageSegment.Top);
  const [facilityName, setFacilityName] = useState<string>('');
  const facilityId: string = sessionStorage.getItem('fid') || '';

  useEffect(() => {
    // 非ログイン状態からの予約のフロー(セッションストレージにfidを保存)で
    // ログイン画面に来た際に、施設名を取得し表示するための処理
    const fetchFacility = async () => {
      try {
        const facilityList = await executeGet<FacilityResponseType>({
          apiName: 'medirecoWebApi',
          path: '/get-facility-list'
        });

        // facilityList から該当する施設を検索
        const facility = facilityList.facilities?.find((facility) => facility.id === facilityId);

        if (facility?.facility_name) {
          // 施設名を状態にセット
          setFacilityName(facility?.facility_name);
        }
      } catch (error) {
        console.error('施設情報の取得に失敗しました:', error);
      }
    };

    // facilityId が存在すればデータを取得
    if (facilityId) {
      fetchFacility();
    }
  }, [facilityId]);

  switch (activePage) {
    case PageSegment.Top:
      return <TopPage setActivePage={setActivePage} facilityName={facilityName} />;
    case PageSegment.Registration:
      return <SignUpPage setActivePage={setActivePage} facilityName={facilityName} />;
    case PageSegment.Login:
      return <LoginPage setActivePage={setActivePage} facilityName={facilityName} fromLine={props.fromLine} />;
    default:
      return <></>;
  }
};

export { RecommendedBrowserPage } from './recommendedBrowser/RecommendedBrowserPage';
